import * as React from 'react';
import { ThemeProvider } from 'styled-components';
import { theme } from 'theme';
import { withAsyncLoad, tokenManager, checkOauthToken } from 'coral-utility';
import { IConnectState } from 'state/ducks/connect/types';
import LandingPage from 'view/landing/_landing';
import { getNavigationAction } from 'state/ducks/navigation/actions';
import NotificationProvider from 'components/NotificationProvider';

interface IProps {
  connect: IConnectState;
}

interface IActions {
  checkOauthToken: typeof checkOauthToken;
  getNavigationAction: typeof getNavigationAction;
}

type AllProps = IProps & IActions;

const AsyncGateway = withAsyncLoad(() => import('./gateway'));

export default class Connect extends React.Component<AllProps, any> {
  /**
   * (1) User has Token?
   *    1. Verify Token
   *        1. isValid?
   *           - Load into the app
   *        2. isNotValid?
   *           - Direct to landing page for sign-in.
   * (2) User does not have Token?
   *    1. - Direct to landing page for sign-in.
   */
  componentDidMount() {
    if (tokenManager.hasToken()) {
      // call user verify action
      this.props.checkOauthToken();
    }
  }

  render() {
    /**
     * (1) Checks for Authentication
     * (2)(Loads Landing Page)
     * (3)(Only renders app when we are fully authenticated)
     */
    return (
      <ThemeProvider theme={theme}>
        <NotificationProvider>
          {tokenManager.hasToken() ? <AsyncGateway {...this.props} /> : <LandingPage />}
        </NotificationProvider>
      </ThemeProvider>
    );
  }
}
